import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, BookOpenIcon } from 'lucide-react';
import { tomos, tomoIncludes } from '../data/content';
export function TomosSection() {
  const [active, setActive] = useState(0);
  const tomo = tomos[active];
  return <section className="w-full bg-ink-950 py-20" aria-labelledby="tomos" style={{
    paddingTop: "30px",
    paddingBottom: "30px"
  }} data-id="element-171" data-mp="1u2n90az22jbc">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6" data-id="element-172" data-mp="xdfo9569ge8h">
        <p className="font-display text-[11px] font-700 uppercase tracking-[0.28em] text-gold" style={{
        fontSize: "16px",
        textAlign: "center"
      }} data-id="element-173" data-mp="11dptugq552mt">
          ¿QUE INCLUYE? 
        </p>
        <h2 id="tomos" className="mt-3 max-w-3xl font-display text-3xl font-900 leading-tight text-white sm:text-4xl" style={{
        paddingTop: "0px",
        paddingBottom: "0px",
        marginTop: "0px",
        marginBottom: "0px"
      }} data-id="element-174" data-mp="1bbvwx1nooet9">
          5 Tomos + 5 Bonos — de no entender nada a decidir con criterio propio
        </h2>

        <div className="mt-10 grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-start" style={{
        gap: "10px"
      }} data-id="element-175" data-mp="2qnp1m1v4x243">
          <div role="tablist" aria-label="Tomos del sistema" className="flex flex-col gap-1.5" data-id="element-176" data-mp="2mkixazrl1l09">
            {tomos.map((item, index) => {
            const isActive = index === active;
            return <button key={item.id} role="tab" id={`tab-${item.id}`} aria-selected={isActive} aria-controls={`panel-${item.id}`} onClick={() => setActive(index)} className={`flex items-center justify-between rounded-lg border px-4 py-3 text-left transition-colors duration-150 ease-smooth ${isActive ? 'border-gold bg-ink-800 text-white' : 'border-ink-800 bg-ink-900 text-slate-400 hover:border-ink-600 hover:text-slate-200'}`} style={{
              paddingTop: "12px",
              paddingBottom: "12px",
              marginTop: "0px",
              marginBottom: "0px"
            }} data-id="element-177" data-mp="2co7gpxkym900" data-mpi={index}>
                  <span className="font-display text-sm font-700 uppercase tracking-wide" data-id="element-178" data-mp="1k0k2r1e72gmc">
                    {item.tab}
                  </span>
                  <span className="ml-4 truncate text-xs text-slate-500" data-id="element-179" data-mp="1fbsgks09kfts">
                    {item.kicker.split('· ')[1]}
                  </span>
                </button>;
          })}
          </div>

          <motion.div key={tomo.id} role="tabpanel" id={`panel-${tomo.id}`} aria-labelledby={`tab-${tomo.id}`} initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.22,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-ink-700 bg-ink-900 p-7 shadow-panel sm:p-9" style={{
          paddingTop: "8px",
          paddingBottom: "8px"
        }} data-id="element-180" data-mp="15cjq494lxjc6">
            
            <p className="mt-5 text-xs font-600 uppercase tracking-[0.2em] text-gold" data-id="element-181" data-mp="2c1s17ktov4sq">
              {tomo.kicker}
            </p>
            <h3 className="mt-2 font-display text-2xl font-800 leading-tight text-white sm:text-3xl" data-id="element-182" data-mp="2gta083c5ivb2">
              {tomo.title}
            </h3>
            <p className="mt-4 text-[15px] leading-relaxed text-slate-300" data-id="element-183" data-mp="5awr33kx54z4">{tomo.description}</p>
          </motion.div>
        </div>

        
      </div>
    </section>;
}